var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcoDollar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "10px",
    height: "20px",
    viewBox: "0 0 10 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "BC520FF8-4CDB-4FC1-891D-A581A0B8FC68") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    transform: "translate(-141.000000, -611.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "dollar",
    transform: "translate(140.000000, 609.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.71,15.884 C10.71,18.509 8.673,20.168 5.712,20.168 C4.011,20.168 2.478,19.79 1.323,19.181 L1.638,17.039 C2.688,17.732 4.179,18.341 5.775,18.341 C7.434,18.341 8.631,17.522 8.631,16.052 C8.631,14.666 7.98,14.099 5.586,13.07 C2.604,11.768 1.491,10.823 1.491,8.639 C1.491,6.182 3.423,4.607 6.279,4.607 C7.812,4.607 8.946,4.964 9.87,5.468 L9.534,7.568 C8.652,6.938 7.476,6.434 6.195,6.434 C4.389,6.434 3.57,7.358 3.57,8.471 C3.57,9.626 4.179,10.172 6.594,11.243 C9.639,12.587 10.71,13.595 10.71,15.884 Z",
    id: "S",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.5,2.84521484 L5.5,21.7851562",
    id: "Path-45",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    fillRule: "nonzero"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoDollar);
export default __webpack_public_path__ + "static/media/ico_dollar.b1a8b9e6d79d036cd47f1b679e861b39.svg";
export { ForwardRef as ReactComponent };